export enum BackEndJobResult {
  Unknown = 0,
  Successful = 1,
  Failed = 2,
  Skipped = 3
}

export const BackEndJobResultMapping: Record<BackEndJobResult, string> = {
  [BackEndJobResult.Unknown]: 'Unknown',
  [BackEndJobResult.Successful]: 'Successful',
  [BackEndJobResult.Failed]: 'Failed',
  [BackEndJobResult.Skipped]: 'Skipped'
};
